import { InfowindowContentBuilder } from '../../../../../shared/utils/infoWindowContentBuilder';
import { InfowindowBuilder } from '../../../../../shared/utils/infowindowBuilder';
import { IMultipleOfferInfoWindow, InfowindowContent } from '../../types';
import indowWindowStyles from '../../../../../shared/styles/infowindow.style';

export const infoWindowContent = ({ payload, id }: InfowindowContent) => {
  const {
    property_age: age,
    address,
    total_ads: ads,
    property_dimensions_m2: dimensions,
    mean_price_m2: meanPrice,
  } = payload;

  const pluralOrSingularAge = (num: number) => {
    if (Math.ceil(num) > 1) {
      return 'anos';
    } else {
      return 'ano';
    }
  };

  const header = `<h6 class="header--title" data-cy="IWBuildingName">Anúncios encontrados</h6>`;

  const body = `<p class="body-contaniner--address" data-cy="IWAddress">${address}</p>
  <div class="body-container--info">
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUnitTotalKey"><strong>Quantidade de anúncios: </strong></p>
      <p class="body-container--info-value" data-cy="IWUnitTotalValue">${ads}</p>
      </div>
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWRealtyTypeKey"><strong>Área privativa: </strong></p>
      <p class="body-container--info-value" data-cy="IWRealtyTypeValue">${dimensions}</p>
      </div>
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUseTypeKey"><strong>Mediana de preço/m²: </strong></p>
      <p class="body-container--info-value" data-cy="IWUseTypeValue">${meanPrice}</p>
      </div>
      <div class="info-container">
        <p class="body-container--info-key" data-cy="IWUseTypeKey${id}"><strong>Idade do imóvel: </strong></p>
        <p class="body-container--info-value" data-cy="IWUseTypeValue">${
          age
            ? `${Math.floor(age)} ${pluralOrSingularAge(age)}`
            : 'Não informado'
        }</p>
      </div>
  </div>`;

  const footer = `
    <button class="infowindow-button" id="SeeAdverts" data-cy="IWBuildingDetailsButton">
      Ver anúncios
    </button>`;

  return new InfowindowContentBuilder({
    header,
    body,
    footer,
  });
};

const infoWindowOffersSecundary = ({
  payload,
  marker,
  map,
  id,
  actions,
}: IMultipleOfferInfoWindow) => {
  return new InfowindowBuilder({
    content: [infoWindowContent({ payload, id })],
    marker: marker as google.maps.Marker,
    map,
    style: indowWindowStyles,
    actions,
  });
};

export default infoWindowOffersSecundary;
